/**
 * 사이트 정적 정보 — 회사명 · 연락처 · 내비게이션.
 * 연락처는 2026-09-03 고객이 준 명함 정보. 이메일은 받은 적 없어 비워 둔다(빈 값은 화면에 나오지 않는다).
 */
export const SITE = {
  name: 'Trinity Laser Profile',
  shortName: 'Trinity',
  tagline: 'Precision fibre laser cutting, quoted from your DXF.',
  region: 'Blacktown NSW · Australia',
  contact: {
    addressLine1: 'Unit 4, 6 Forge St',
    addressLine2: 'Blacktown NSW 2148',
    phone: '0413 431 535',
    phoneHref: 'tel:+61413431535',
    website: 'trinitylaserprofile.com',
    websiteHref: 'https://trinitylaserprofile.com',
    email: ''
  },
  legal: {
    abn: 'ABN 46 682 836 933'
  },
  social: []
};

/** 사이트 팩트 — 히어로 · 신뢰 스트립 등에 반복 사용 */
export const FACTS = [
  { value: '±0.1', unit: 'mm', label: 'cutting tolerance' },
  { value: '0.15', unit: 'mm', label: 'kerf width' },
  { value: '25', unit: 'mm', label: 'max stainless' },
  { value: '24', unit: 'h', label: 'quote turnaround' }
];

export const NAV = {
  primary: [
    { to: '/', label: 'Home', end: true },
    {
      label: 'Services',
      children: [
        { to: '/quote', label: 'Request a quote', desc: 'Upload DXF, get an indicative price' },
        { to: '/materials', label: 'Materials', desc: 'Stock sheets, grades & thicknesses' },
        { to: '/viewer', label: 'DXF viewer', desc: 'Check a drawing before you quote it' }
      ]
    },
    { to: '/gallery', label: 'Gallery' },
    {
      label: 'Support',
      children: [
        { to: '/faq', label: 'FAQ', desc: 'Files, tolerances, lead times' },
        { to: '/contact', label: 'Contact us', desc: 'Talk to an estimator' }
      ]
    }
  ],
  footer: [
    {
      title: 'Services',
      links: [
        { to: '/quote', label: 'Request a quote' },
        { to: '/materials', label: 'Materials' },
        { to: '/gallery', label: 'Gallery' },
        { to: '/viewer', label: 'DXF viewer' }
      ]
    },
    {
      title: 'Account',
      links: [
        { to: '/mypage', label: 'My page' },
        { to: '/mypage/orders', label: 'Orders' },
        { to: '/mypage/quotes', label: 'Quotes' },
        { to: '/mypage/certificates', label: 'Certificates' }
      ]
    },
    {
      title: 'Support',
      links: [
        { to: '/faq', label: 'FAQ' },
        { to: '/contact', label: 'Contact us' },
        { to: '/search', label: 'Search' }
      ]
    },
    {
      title: 'Company',
      links: [
        { to: '/about', label: 'About Trinity' },
        { to: '/terms', label: 'Terms of service' },
        { to: '/privacy', label: 'Privacy policy' }
      ]
    }
  ]
};
